import { SuperSchema } from '@updater/ui-informant';
import { internetUsersMerchandisingSchema } from './pages/internetUsers.schema';
import { internetUsageMerchandisingSchema } from './pages/internetUsage.schema';

/**
 * The quiz's questions as a single schema.
 *
 * The first question sits at the top level. Every later one goes under an
 * always-true `if`/`then`, which scopes its `required` to its own screen --
 * at the top level it would make the first screen invalid before the visitor
 * ever reached it.
 *
 * This used to be built by a helper that passed a page through unwrapped when
 * the page carried its own conditional. Only the retired quiz's pages did
 * (their `conditions.ts` drove the branching question order), so that path
 * became unreachable when they were deleted and went with them (COREX-1934).
 */
export const merchandisingSchema: SuperSchema = {
  ...internetUsersMerchandisingSchema,
  allOf: [{ if: {}, then: internetUsageMerchandisingSchema }],
  $id: 'provider-app-quiz-merchandising',
};
